import { isResponse, toData } from '@mmx/shared'
import { merge } from 'rxjs'
import { filter, map, scan, share } from 'rxjs/operators'

import { AdvancedTableApiDeletionService } from './advanced-table-api-service'
import { AdvancedTableDataSource, MaybeNewRecord } from './advanced-table-datasource'

export interface MaybeNewHideableRecord extends MaybeNewRecord {
  hidden?: boolean
}

export const advancedTableDeletionDatasourceFactory = <T extends MaybeNewHideableRecord>(
  apiService: AdvancedTableApiDeletionService<T>,
) => {
  return new AdvancedTableDeletionDataSource<T>(apiService)
}

export class AdvancedTableDeletionDataSource<RowModel extends MaybeNewHideableRecord>
  extends AdvancedTableDataSource<RowModel, AdvancedTableApiDeletionService<RowModel>>
{
  deleteRecord$ = this.apiService.deleteResponse$.pipe(
    filter(isResponse),
    map(toData),
    share(),
  )

  // remove deleted records from current collection
  protected dataRow$ = merge(this.internalDataRow$, this.deleteRecord$).pipe(
    scan((acc: RowModel[], record: RowModel | RowModel[]) => {
      if (Array.isArray(record)) {
        return record.filter(r => !r.hidden) as RowModel[]
      }

      if (record.hidden) {
        return acc.filter(r => r.id !== record.id)
      }

      return acc
    }, []),
  )
}
